import { enumErrorResponse } from "../data/enums/errorResponse"
import { sessionExpired } from "../redux/slices/authSlice"
import { createApiMessage } from "../redux/slices/snackbarSlice"

const loginApi = (url = '') => url.includes('/auth/')

export const parseErrorMessage = (code, language) => {
  return enumErrorResponse[language || 'EN'][code] || enumErrorResponse[language || 'EN'].default
}
export const apiErrorSnackbarOptions = (key = 0) => ({
  variant: 'error', key, anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
})

export const globalResponseErrorHandler = (error, store) => {

  const requestUrl = error?.config?.url

  const responseStatus = error?.response?.status
  const internalErrorCode = error?.response?.data?.code || 0
  const message = parseErrorMessage(internalErrorCode)
  console.log({ title: 'Global error handler', internalErrorCode, responseStatus, message, error })

  if (internalErrorCode === 8) {
    const field = error?.response?.data?.message
    if (field) return ({ message, field })
  }
  if (internalErrorCode === 9) {
    const field = error?.response?.data?.message
    if (field) return ({ message, field })
  }

  switch (responseStatus) {
    case 401:
      if (!loginApi(requestUrl)) store.dispatch(sessionExpired())
      break;

    default:
      break;
  }
  const key = new Date().getTime() + Math.random()

  store.dispatch(createApiMessage({ message, key, options: apiErrorSnackbarOptions(key) }))
  return ({ message })
}
